import contr from './init/controller';

contr.init();

window.onload = () => {
	contr.loaded();
}

window.onresize = () => {
	contr.resized();
}

jQuery(window).on("scroll", function(){
	contr.scrolled();
});




// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/script.js